import { Link } from 'react-router-dom';
import {
  useDeleteStudentRequestMutation,
  useGetStudentRequestsQuery,
} from '@/entities/StudentRequests';
import TrashIcon from '@/shared/assets/icons/trash.svg';
import { Svg } from '@/shared/ui/Svg';
import {
  REQUEST_REASON_LABELS,
  REQUEST_STATUS_CLASSES,
  REQUEST_STATUS_LABELS,
  formatRequestDate,
} from '../../ui/components/requestUi';

export const MyRequests = () => {
  const { data: requests = [], isLoading } = useGetStudentRequestsQuery();
  const [deleteStudentRequest] = useDeleteStudentRequestMutation();

  if (isLoading) {
    return <div className="py-8 text-center text-grey-secondary">Loading requests...</div>;
  }

  if (!requests.length) {
    return (
      <div className="flex flex-col items-start gap-4">
        <p className="text-grey-secondary">No requests yet.</p>
        <Link
          to="/profile/request/create"
          className="flex h-12 min-w-[220px] items-center justify-center rounded-xl bg-red px-6 text-base font-medium text-white"
        >
          Create request
        </Link>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-lg border border-[#E5E7EB]">
      <table className="w-full border-collapse">
        <caption className="sr-only">My requests</caption>
        <thead>
          <tr className="h-12 bg-white text-left text-sm font-semibold text-grey-description">
            <th scope="col" className="px-5">
              Date
            </th>
            <th scope="col" className="px-5">
              Reason
            </th>
            <th scope="col" className="px-5">
              Closed
            </th>
            <th scope="col" className="w-14 px-4">
              <span className="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {requests.map((request) => (
            <tr
              key={request.id}
              className={`h-16 border-t border-[#E5E7EB] text-sm ${
                request.status === 'approved'
                  ? 'bg-[#E8F8F1]'
                  : request.status === 'rejected'
                    ? 'bg-[#FDE8E8]'
                    : 'bg-white'
              }`}
            >
              <td className="px-5">
                <Link to={`/profile/requests/${request.id}`} className="block">
                  {formatRequestDate(request.createdAt ?? request.startDate ?? request.resolvedAt)}
                </Link>
              </td>
              <td className="px-5">
                <Link to={`/profile/requests/${request.id}`} className="block">
                  {REQUEST_REASON_LABELS[request.reason]}
                </Link>
              </td>
              <td className="px-5">
                <Link to={`/profile/requests/${request.id}`} className="block">
                  {request.resolvedAt ? (
                    formatRequestDate(request.resolvedAt)
                  ) : (
                    <span
                      className={`rounded px-2 py-1 text-xs font-medium ${REQUEST_STATUS_CLASSES[request.status]}`}
                    >
                      {REQUEST_STATUS_LABELS[request.status]}
                    </span>
                  )}
                </Link>
              </td>
              <td className="px-4">
                {request.status === 'new' && (
                  <button
                    type="button"
                    aria-label="Delete request"
                    className="cursor-pointer p-2"
                    onClick={() => deleteStudentRequest(request.id)}
                  >
                    <Svg Icon={TrashIcon} className="h-5 w-5 text-grey-secondary" />
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
